import apiCall from '@/utils/api'

const state = {
    submittedExpressions: [],
    submittedExpressionPagination: {
        search: ' ',
        current_page: 1,
        per_page: 0,
        total: 0,
        visible: 10
    },
    submittedExpressionLoader: false,

    reviewExpressions: [],
    reviewExpressionPagination: {
        search: ' ',
        current_page: 1,
        per_page: 0,
        total: 0,
        visible: 10
    },
    reviewExpressionLoader: false,

    rejectedExpressions: [],
    rejectedExpressionPagination: {
        search: ' ',
        current_page: 1,
        per_page: 0,
        total: 0,
        visible: 10
    },
    rejectedExpressionLoader: false,

    selectedForRatingExpressions: [],
    selectedForRatingExpressionPagination: {
        search: ' ',
        current_page: 1,
        per_page: 0,
        total: 0,
        visible: 10
    },
    selectedForRatingExpressionLoader: false,

    shortlistedExpressions: [],
    shortlistedExpressionPagination: {
        search: ' ',
        current_page: 1,
        per_page: 0,
        total: 0,
        visible: 10
    },
    shortlistedExpressionLoader: false,
};

const getters = {
    submittedExpressions: (state) => state.submittedExpressions,
    submittedExpressionLoader: (state) => state.submittedExpressionLoader,
    submittedExpressionPagination: (state) => state.submittedExpressionPagination,

    reviewExpressions: (state) => state.reviewExpressions,
    reviewExpressionLoader: (state) => state.reviewExpressionLoader,
    reviewExpressionPagination: (state) => state.reviewExpressionPagination,

    rejectedExpressions: (state) => state.rejectedExpressions,
    rejectedExpressionLoader: (state) => state.rejectedExpressionLoader,
    rejectedExpressionPagination: (state) => state.rejectedExpressionPagination,

    selectedForRatingExpressions: (state) => state.selectedForRatingExpressions,
    selectedForRatingExpressionLoader: (state) => state.selectedForRatingExpressionLoader,
    selectedForRatingExpressionPagination: (state) => state.selectedForRatingExpressionPagination,

    shortlistedExpressions: (state) => state.shortlistedExpressions,
    shortlistedExpressionLoader: (state) => state.shortlistedExpressionLoader,
    shortlistedExpressionPagination: (state) => state.shortlistedExpressionPagination,
}

const actions = {
    async fetchSubmittedExpressions({commit}, page) {
        const response = await apiCall({url: `/api/expression?type=submitted&page=${page}`, method: 'GET' });
        commit('setSubmittedExpressions', response)
        commit('stopSubmittedExpressionLoader', response)
    },
    async filterSubmittedExpressions({commit, state},resp){
        commit('setSubmittedExpressions', resp)
    },
    async startSubmittedExpressionLoader({commit, state},resp){
        commit('startSubmittedExpressionLoader', resp)
    },
    async stopSubmittedExpressionLoader({commit, state},resp){
        commit('stopSubmittedExpressionLoader', resp)
    },

    async fetchReviewExpressions({commit}, page) {
        const response = await apiCall({url: `/api/expression?type=review&page=${page}`, method: 'GET' });
        commit('setReviewExpressions', response)
        commit('stopReviewExpressionLoader', response)
    },
    async filterReviewExpressions({commit, state},resp){
        commit('setReviewExpressions', resp)
    },
    async startReviewExpressionLoader({commit, state},resp){
        commit('startReviewExpressionLoader', resp)
    },
    async stopReviewExpressionLoader({commit, state},resp){
        commit('stopReviewExpressionLoader', resp)
    },

    async fetchRejectedExpressions({commit}, page) {
        const response = await apiCall({url: `/api/expression?type=rejected&page=${page}`, method: 'GET' });
        commit('setRejectedExpressions', response)
        commit('stopRejectedExpressionLoader', response)
    },
    async filterRejectedExpressions({commit, state},resp){
        commit('setRejectedExpressions', resp)
    },
    async startRejectedExpressionLoader({commit, state},resp){
        commit('startRejectedExpressionLoader', resp)
    },
    async stopRejectedExpressionLoader({commit, state},resp){
        commit('stopRejectedExpressionLoader', resp)
    },

    async fetchSelectedForRatingExpressions({commit}, page) {
        const response = await apiCall({url: `/api/expression?type=selected-for-rating&page=${page}`, method: 'GET' });
        commit('setSelectedForRatingExpressions', response)
        commit('stopSelectedForRatingExpressionLoader', response)
    },
    async filterSelectedForRatingExpressions({commit, state},resp){
        commit('setSelectedForRatingExpressions', resp)
    },
    async startSelectedForRatingExpressionLoader({commit, state},resp){
        commit('startSelectedForRatingExpressionLoader', resp)
    },
    async stopSelectedForRatingExpressionLoader({commit, state},resp){
        commit('stopSelectedForRatingExpressionLoader', resp)
    },

    async fetchShortlistedExpressions({commit}, page) {
        const response = await apiCall({url: `/api/expression?type=shortlisted&page=${page}`, method: 'GET' });
        commit('setShortlistedExpressions', response)
        commit('stopShortlistedExpressionLoader', response)
    },
    async filterShortlistedExpressions({commit, state},resp){
        commit('setShortlistedExpressions', resp)
    },
    async startShortlistedExpressionLoader({commit, state},resp){
        commit('startShortlistedExpressionLoader', resp)
    },
    async stopShortlistedExpressionLoader({commit, state},resp){
        commit('stopShortlistedExpressionLoader', resp)
    },
};

const mutations = {
    setSubmittedExpressions: (state, submittedExpressions) => {
        state.submittedExpressions = submittedExpressions.data
        state.submittedExpressionPagination.current_page = submittedExpressions.current_page
        state.submittedExpressionPagination.total = submittedExpressions.total
        state.submittedExpressionPagination.per_page = submittedExpressions.per_page
    },
    startSubmittedExpressionLoader: (state) => state.submittedExpressionLoader = true,
    stopSubmittedExpressionLoader: (state) => state.submittedExpressionLoader = false,

    setReviewExpressions: (state, reviewExpressions) => {
        state.reviewExpressions = reviewExpressions.data
        state.reviewExpressionPagination.current_page = reviewExpressions.current_page
        state.reviewExpressionPagination.total = reviewExpressions.total
        state.reviewExpressionPagination.per_page = reviewExpressions.per_page
    },
    startReviewExpressionLoader: (state) => state.submittedExpressionLoader = true,
    stopReviewExpressionLoader: (state) => state.submittedExpressionLoader = false,

    setRejectedExpressions: (state, rejectedExpressions) => {
        state.rejectedExpressions = rejectedExpressions.data
        state.rejectedExpressionPagination.current_page = rejectedExpressions.current_page
        state.rejectedExpressionPagination.total = rejectedExpressions.total
        state.rejectedExpressionPagination.per_page = rejectedExpressions.per_page
    },
    startRejectedExpressionLoader: (state) => state.submittedExpressionLoader = true,
    stopRejectedExpressionLoader: (state) => state.submittedExpressionLoader = false,

    setSelectedForRatingExpressions: (state, selectedForRatingExpressions) => {
        state.selectedForRatingExpressions = selectedForRatingExpressions.data
        state.selectedForRatingExpressionPagination.current_page = selectedForRatingExpressions.current_page
        state.selectedForRatingExpressionPagination.total = selectedForRatingExpressions.total
        state.selectedForRatingExpressionPagination.per_page = selectedForRatingExpressions.per_page
    },
    startSelectedForRatingExpressionLoader: (state) => state.submittedExpressionLoader = true,
    stopSelectedForRatingExpressionLoader: (state) => state.submittedExpressionLoader = false,

    setShortlistedExpressions: (state, shortlistedExpressions) => {
        state.shortlistedExpressions = shortlistedExpressions.data
        state.shortlistedExpressionPagination.current_page = shortlistedExpressions.current_page
        state.shortlistedExpressionPagination.total = shortlistedExpressions.total
        state.shortlistedExpressionPagination.per_page = shortlistedExpressions.per_page
    },
    startShortlistedExpressionLoader: (state) => state.shortlistedExpressionLoader = true,
    stopShortlistedExpressionLoader: (state) => state.shortlistedExpressionLoader = false,
};

export default {
    state,
    getters,
    actions,
    mutations
}
